import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';

const TextAreaCustom = (props) => {
  return (
    <Form.Group>
      {props.label ? <Form.Label className="text-light">{props.label}</Form.Label> : null}
      <Form.Control
        value={props.value}
        className="input-control w-100"
        as={'textarea'}
        placeholder={props.placeholder}
        defaultValue={props.defaultValue}
        onChange={(e) => props.onChange(e.target.value)}
        min={props.type === 'number' ? props.min : ''}
        isInvalid={props.error ? true : false}
        rows={4}
        readOnly={props.readOnly}
      />
      <Form.Control.Feedback type="invalid">{props.error}</Form.Control.Feedback>
    </Form.Group>
  );
};

TextAreaCustom.propTypes = {
  error: PropTypes.string,
  label: PropTypes.string,
  min: PropTypes.number,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
};

export default TextAreaCustom;
